/**
 * File will hold application enums.
 */

export default {
  UserRegistrationStatus: {
    Unregistered: 1,
    RegisteredWithoutAccount: 2,
    RegisteredWithAccount: 4,
    RegisteredWithUnconfirmedAccount: 8,
    InvalidEmail: 16,
    FreeMail: 32,
    RegisteredUnconfirmedWithoutAccount: 64,
  },
  QuestionStatus: {
    Current: 'Current',
    Next: 'Next',
    Pristine: 'Pristine',
    Answered: 'Answered',
    Ignored: 'Ignored'
  },
  QandATypes: {
    None: 'None',
    TextOnly: 'TextOnly',
    AudioOnly: 'AudioOnly',
    TextAndAudio: 'TextAndAudio'
  }

}
